import CalendarDay from './CalendarDay';
import type { Slot } from '../state';

interface DayCell {
  dateStr: string;
  dayNum: number;
  slots: Slot[];
  isSelected: boolean;
  isOtherMonth: boolean;
}

interface CalendarWeekProps {
  days: DayCell[];
  onDayClick: (dateStr: string) => void;
  reactionsByUserBySlot?: Record<number, Record<string, string>>;
}

export default function CalendarWeek({
  days,
  onDayClick,
  reactionsByUserBySlot = {},
}: CalendarWeekProps) {
  return (
    <tr>
      {days.map((d, i) => (
        <td
          key={d.dateStr || `empty-${i}`}
          className="p-0 align-top border border-black dark:border-gray-800 calendar-cell"
        >
          <CalendarDay
            dateStr={d.dateStr}
            dayNum={d.dayNum}
            slots={d.slots}
            isSelected={d.isSelected}
            isOtherMonth={d.isOtherMonth}
            onDayClick={onDayClick}
            reactionsByUserBySlot={reactionsByUserBySlot}
          />
        </td>
      ))}
    </tr>
  );
}
